import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-pipelines',
  templateUrl: './help-pipelines.component.html',
  styleUrls: ['./help-pipelines.component.scss']
})
export class HelpPipelinesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
